import { render, staticRenderFns } from "./ContactPersonCreationModal.vue?vue&type=template&id=b4982ee8&scoped=true"
import script from "./ContactPersonCreationModal.vue?vue&type=script&lang=js"
export * from "./ContactPersonCreationModal.vue?vue&type=script&lang=js"
import style0 from "./ContactPersonCreationModal.vue?vue&type=style&index=0&id=b4982ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4982ee8",
  null
  
)

export default component.exports